import { Component, ChangeDetectorRef, Output, OnInit, EventEmitter, Input } from '@angular/core';
import * as dicomParser from "dicom-parser";

@Component({
  selector: 'app-drag-and-drop-upload',
  templateUrl: './drag-and-drop-upload.component.html',
  styleUrls: ['./drag-and-drop-upload.component.scss']
})

export class DragAndDropUploadComponent {

  canDropFolder = typeof DataTransferItem.prototype.webkitGetAsEntry === 'function';
  uploadPaths = [];
  files: Object;
  scannedFiles: any = [];
  upload_count: number = 0

  @Input() dragMessage
  @Output() fileSelection = new EventEmitter();

  constructor(private cdr: ChangeDetectorRef) {
    this.files = {};
  }

  dragenter(ev) {
    return Array.prototype.every.call(
      ev.dataTransfer.items,
      item => item.kind !== 'file'
    );
  }

  dragover(ev) {
    return Array.prototype.every.call(
      ev.dataTransfer.items,
      item => item.kind !== 'file'
    );
  }

  uploadCallBack() {
    console.log("this.scannedFiles", JSON.stringify(this.scannedFiles));
  }

  drop(event) {
    const entries = Array.from(event.dataTransfer.items)
      .filter(item => (<DataTransferItem>item).kind === 'file')
      .map(item => (<DataTransferItem>item).webkitGetAsEntry());
    this.buildTree(entries, '').then(() => {
      let scannedFiles = this.scannedFiles;
      this.fileSelection.emit(<FileList>scannedFiles)
    });
    return false;
  }

  private buildTree(entries, name) {
    const tree = { name, files: [], directories: [] };
    const promises = [];
    entries.forEach(entry => {
      if (entry.isFile) {
        const promise = this.parseFileEntry(entry)
          .then(file => {
            tree.files.push(file)
            this.scannedFiles.push(file)
          });
        promises.push(promise);
      }
      else if (entry.isDirectory) {
        const promise = this.parseDirectoryEntry(entry)
          .then(directory => {
            tree.directories.push(directory)
          });
        promises.push(promise);
      }
    });
    return Promise.all(promises);
  }

  parseFileEntry(fileEntry) {
    return new Promise((resolve, reject) => {
      fileEntry.file(
        file => { resolve(file) },
        err => { reject(err) }
      );
    });
  }

  parseDirectoryEntry(directoryEntry) {
    const directoryReader = directoryEntry.createReader();
    return new Promise((resolve, reject) => {
      directoryReader.readEntries(
        entries => {
          resolve(this.buildTree(entries, directoryEntry.name));
        },
        err => {
          reject(err);
        }
      );
    });
  }

  filesPicked(files) {
    this.uploadPaths = [];
    Array.prototype.forEach.call(files, file => {
      this.uploadPaths.push(file.webkitRelativePath);
    });
  }

  scanFiles(item, container) {
    let elem = document.createElement("li");
    elem.innerHTML = item.name;
    container.appendChild(elem);

    if (item.isDirectory) {
      let directoryReader = item.createReader();
      let directoryContainer = document.createElement("ul");
      container.appendChild(directoryContainer);
      directoryReader.readEntries(entries => {
        entries.forEach(entry => {
          this.scanFiles(entry, directoryContainer);
        });
      });
    }
  }

  async get_scanedFiles(item, container) {
    let elem = document.createElement("li");
    elem.innerHTML = item.name;
    container.appendChild(elem);

    if (item.isFile) {
      item.file(file => {
        this.scannedFiles.push(file)
        /*
          let reader = new FileReader();
          reader.onload = function () {
          let data = reader.result;
          let array = new Uint8Array(<ArrayBuffer>data);
          console.log("Uint8Array", array)

          let dataset = dicomParser.parseDicom(array);
            console.log("dataset", dataset)
          }
          console.log("reader.readAsArrayBuffer(item)", reader.readAsArrayBuffer(file)) 
        */
      })
    }

    if (item.isDirectory) {
      let directoryReader = item.createReader();
      let directoryContainer = document.createElement("ul");
      container.appendChild(directoryContainer);
      directoryReader.readEntries(entries => {
        entries.forEach(entry => {
          this.get_scanedFiles(entry, directoryContainer);
        });
      });
    }

    return true;
  }

  fileApplyExtensionFilter(file) {
    return new Promise((resolve, reject) => {
      let dataset = ''
      let reader = new FileReader();
      reader.onload = () => {
        let data = reader.result;
        let array = new Uint8Array(<ArrayBuffer>data);
        dataset = dicomParser.parseDicom(array).elements['x0020000d'];
        resolve(dataset)
      }
      reader.onerror = (e) => {
        reject(e)
      }
      reader.readAsArrayBuffer(file)
    })
  }

  async util_asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
    }
  }

  upload(tree, path) {
    tree.files.forEach(file => {
      this.uploadPaths.push(path + file.name);
    });
    tree.directories.forEach(directory => {
      const newPath = path + directory.name + '/';
      this.uploadPaths.push(newPath);
      this.upload(directory, newPath);
    });
  }
}
